import { Outlet, useNavigate } from "react-router-dom";
import TrowelHeader from "../components/header";
import TrowelSideMenu from "../components/side-menu";
import "./user-layout.scss";
import { IMenuNavItem } from "../common/inerfaces/component-interfaces";

const UserLayout: React.FC = () => {
  const navigate = useNavigate();
  const menuItemSelectionChangeHandler = (menuItem: IMenuNavItem) => {
    navigate(menuItem.path);
  };
  return (
    <main className="user-layout-main">
      <div className="linear-gradient-circle"></div>
      <div className="linear-gradient-circle botton-gradient"></div>

      <TrowelHeader />
      <main className="layout-body">
        <TrowelSideMenu onNavigationChange={menuItemSelectionChangeHandler} />
        <section className="layout-body__wrapper">
          <Outlet />
        </section>
      </main>
    </main>
  );
};

export default UserLayout;
